<template>
  <div>
    <vs-table class="text-nowrap" max-items="15" pagination :data="history">
      <template slot="thead">
        <vs-th>Data</vs-th>
        <vs-th>Nazwa</vs-th>
        <vs-th>Typ</vs-th>
        <vs-th>Liczba punktów</vs-th>
        <vs-th>Saldo po zmianie</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr class="border-top" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="d-flex no-block align-items-center">
              <div class>
                <h5 class="mb-0 font-16 font-medium">{{ data[indextr].date }}</h5>
                <span>{{ data[indextr].time }}</span>
              </div>
            </div>
          </vs-td>
          <vs-td>{{ data[indextr].description }}</vs-td>
          <vs-td>
            <div class="d-flex align-items-center">
              <span :class='"text-"+setStatusColor(data[indextr].status, data[indextr].value)'>{{setStatusDescription(data[indextr].status, data[indextr].value)}}</span>
            </div>
          </vs-td>
          <vs-td>{{ data[indextr].value }}</vs-td>
          <vs-td>
            <span class="font-medium">{{ data[indextr].saldo }}</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
export default {
  name: "PointTable",
  props: {
    history: {
      required: true
    }
  },
  data: () => ({
    title: "PointTable",
    paginationtable: false
  }),
  methods: {
    setStatusColor(status, value){
      if(value<0) return "danger";
      else if(status.name === "unlocked") return "success";
      else if(status.name === "locked") return "warning";
    },
    setStatusDescription(status, value){
      if(value<0) return "Odjęcie punktów";
      else return status.description;
    }
  }
};
</script>